export default __webpack_public_path__ + "static/media/out.000ad5a0.svg";